import {v$} from './helpers.js';
// elements
//functions 
export const openPopup = (popup) => {
    popup.classList.add('active');
    // document.body.style.overflow = 'hidden';
    document.body.classList.add('overflow-hidden');
};
export const closePopup = (popup) => {
    popup.classList.remove('active');
    // document.body.style.overflow = 'auto';
    document.body.classList.remove('overflow-hidden');
};
const handlePopup = (popup,trigerBtn) => {
    let popupClose = v$('.popup-close',popup)[0];
    //listeners
        popupClose.addEventListener('click',e => {
            closePopup(popup);
        });
    if(trigerBtn){
        trigerBtn.addEventListener('click',e => {
            e.preventDefault();
            openPopup(popup);
        })
    }
}
export default handlePopup;
